import { Reporter } from 'features/dataCapture';
import { addToCart as addToCartRequest, redirectToCart } from 'features/cart';
import { visibilityObserver as productImpressionsVisibilityObserver } from 'features/product';
import { showAddToCartFailureModal } from 'features/cart/desktop';
import { wishListErrorMessages } from 'features/wishList/desktop';
import { addClassDuringActivity } from 'utilities/dom';
import { ProductImpressionsReporter, trackWishlistActions } from 'features/tealium';
import { trackAddToCartDy } from 'features/tealium/dynamicYield';
import { ProductImpressionsReporter as ProductImpressionsGa4Reporter } from 'features/tealium/ga4/ecommerce';
import decodeHtml from 'utilities/decodeHtml';
import { dataCaptureTimeout } from 'ui/config';
import { formatCurrency } from 'utilities/localization';

import showWishListErrorModal from '../showWishListErrorModal';
import loadWishListItems from '../loadWishListItems';

const { reporter } = window.lp.dataCapture;

let removeItemErrorCallback;

const WishlistItemView = Backbone.Marionette.ItemView.extend({
	template: false,
	ui: {
		ctrlRemove: '.ctrlRemove',
		wishlistQty: '.wishlistQty',
		addToCartButton: '.lnkAddToCart',
		wishlistItemName: '.wishlistItemName',
		moreLikeThisBtn: '.moreLikeThisBtn',
		continueShoppingLink: '.wlContinueShopping'
	},
	events: {
		'click @ui.ctrlRemove': 'removeWishListItem',
		'change @ui.wishlistQty': 'updateQuantity',
		'keydown @ui.wishlistQty': 'updateQuantityOnEnter',
		'click @ui.addToCartButton': 'addItemToCart',
		'click @ui.wishlistItemName': 'handleWishlistItemNameClick',
		'click @ui.moreLikeThisBtn': 'handleMoreLikeThisClick',
		'click @ui.continueShoppingLink': () => trackWishlistActions({ eventAction: 'Click-Continue-Shopping' })
	},

	initialize () {

		const that = this;
		this.bindUIElements();
		this.setImpressionObserver();

		$(lp).on('rebindUIElements', () => {

			that.bindUIElements();
			that.setImpressionObserver();

		});

	},
	removeWishListItem (e) {

		e.preventDefault();
		const $removeLink = $(e.target);
		let wishlistItemId;
		let $wishlistItem;
		let viewType;

		if (!$removeLink.is('.disabled')) {

			trackWishlistActions({
				eventAction: 'Remove-Product',
				eventLabel: e.currentTarget.dataset.sku || ''
			});

			wishlistItemId = $removeLink.data('itemId');
			$wishlistItem = $(`.wishlistItem-${wishlistItemId}`);
			viewType = $('.wishlistView').attr('id');

			window.lp.utils.showStatusIndicator();
			$wishlistItem.addClass('deleteInProgress');

			// lazy load the removeItemErrorCallback function
			if (!removeItemErrorCallback) {

				removeItemErrorCallback = function (error) {

					window.lp.utils.hideStatusIndicator();
					$wishlistItem.removeClass('deleteInProgress');
					$removeLink.removeClass('disabled');
					$('#wishlistBody').removeData('currentSlideIndex');
					showWishListErrorModal({ errorMessage: error });

				};

			}

			$.ajax({
				type: 'POST',
				url: `/api/globalwishlists/items/${lp.wishlist.wishlistToken}/${wishlistItemId}`,
				success (response) {

					if (response) {

						if (response.Success) {

							loadWishListItems(viewType, () => {

								$wishlistItem.removeClass('deleteInProgress');

							});

						} else {

							removeItemErrorCallback(wishListErrorMessages[response.ErrorMessage || 'Failure']);

						}

					} else {

						removeItemErrorCallback(wishListErrorMessages.Failure);

					}

				},
				error () {

					removeItemErrorCallback(wishListErrorMessages.Failure);

				}
			});

		}
		$removeLink.addClass('disabled');

	},

	updateQuantityOnEnter (e) {

		if (e.keyCode === 13) {

			$(e.target).trigger('blur'); // if qty is changed, this will trigger 'change' event and call updateQuantity function

		}

	},

	updateQuantity (e) {

		const $qtyField = $(e.target);
		let qty = $qtyField.val();

		// if qty is empty, reset to original qty
		if (qty === '') {

			$qtyField.val($qtyField.data('origValue'));
			return;

		}

		qty = Number(qty) || 1;
		$qtyField.val(qty);

		// this occurs if user entered leading zeroes and the original qty is numerically the same (e.g. 001 == 1)
		if (qty === Number($qtyField.data('origValue'))) {

			return;

		}

		$qtyField.prop('readonly', true).after('<div class="loadingIcon"></div>');
		window.lp.utils.showStatusIndicator('Updating quantity...');

		$.ajax({
			type: 'PUT',
			url: `/api/globalwishlists/items/${$qtyField.data('itemId')}/quantity`,
			data: {
				Quantity: qty,
				WishListToken: lp.wishlist.wishlistToken
			},
			success (response) {

				if (response) {

					if (response.Success) {

						$qtyField.data('origValue', qty);

						// Update Total
						$.get('/api/globalwishlists/total', (response) => {

							const responseNumber = Number(response);
							if (responseNumber !== null && !Number.isNaN(responseNumber)) {

								const total = formatCurrency(responseNumber.toFixed(2));
								$('.wishlistTotal').html(total);

							}

						});

						window.lp.utils.getAssetCounts();

					} else {

						$qtyField.val($qtyField.data('origValue'));
						showWishListErrorModal({
							errorMessage: wishListErrorMessages[response.ErrorMessage || 'Failure']
						});

					}

				} else {

					$qtyField.val($qtyField.data('origValue'));
					showWishListErrorModal({ errorMessage: wishListErrorMessages.Failure });

				}

			},
			error () {

				$qtyField.val($qtyField.data('origValue'));
				showWishListErrorModal({ errorMessage: wishListErrorMessages.Failure });

			},
			complete () {

				$qtyField.prop('readonly', false);
				setTimeout(() => {

					$qtyField.next('.loadingIcon').remove();
					window.lp.utils.hideStatusIndicator();

				}, 500);

			}
		});

	},

	addItemToCart (e) {

		e.preventDefault();
		const $el = $(e.target).closest('.lnkAddToCart');
		const itemId = $el.attr('data-item-id');
		const data = [];
		const $qtyField = $(`.wishlistQty[data-item-id="${itemId}"]`);
		const item = {
			ShortSku: $el.data('sku').toString(),
			Quantity: '1',
			Name: decodeHtml($el.data('name')),
			Category: $el.data('category'),
			Brand: $el.data('brand'),
			Price: $el.data('price'),
			SkuInputType: $el.data('skuInputType')
		};

		trackWishlistActions({ eventAction: 'click-Add to Cart' });

		if ($qtyField) {

			if ($qtyField.val() !== '') {

				item.Quantity = $qtyField.val();

			} else {

				item.Quantity = $qtyField.attr('data-orig-value');

			}

		}

		item.customizedProductToken = $el.attr('data-customized-product-token');

		// If item has a pattern, build out Pattern Color Combination
		if ($el.attr('data-json-pattern')) {

			const info = JSON.parse($el.attr('data-json-pattern'));
			const pcc = {
				LayerColor1: info.Color1,
				LayerColor2: info.Color2,
				LayerColor3: info.Color3,
				LayerColor4: info.Color4,
				LayerColor5: info.Color5,
				PatternId: info.PatternId,
				Trim: info.Trim
			};
			item.PatternColorCombination = pcc;

		}

		data.push(item);

		let addToCartRecordId;
		if (window.lp.globals.enableDataCapture) {

			// deep clone and add customizedProductCombination property
			// and remove PatternColorCombination if it is custom product
			const { customizedProductCombination } = $el[0].dataset;
			const PatternColorCombination = customizedProductCombination ? null : item.PatternColorCombination;
			const dataCaptureItem = {
				...data[0],
				customizedProductCombination,
				PatternColorCombination
			};

			reporter.trackAddToCart([ dataCaptureItem ], e.currentTarget);
			addToCartRecordId = reporter.getLastRecordId();

		}

		const waitForDataCaptureAndRedirectToCart = () => {

			if (!window.lp.globals.enableDataCapture) {

				redirectToCart();
				return;

			}

			const currentElement = e.target.closest('.lnkAddToCart');
			const currentSku = currentElement.getAttribute('data-sku');
			const pageImg = document.querySelector(`.wishlistView [data-sku='${currentSku}']`);
			const skuViewRecord = reporter.getRecordByElement(pageImg);
			const skuViewRequest = skuViewRecord
				? skuViewRecord.promise
				: reporter.track(Reporter.getSkuViewData(pageImg));
			const atcRecord = reporter.getRecordById(addToCartRecordId);
			const atcRequest = atcRecord.promise;
			const timeout = window.setTimeout(redirectToCart, dataCaptureTimeout);
			Promise.all([ skuViewRequest, atcRequest ]).finally(() => {

				window.clearTimeout(timeout);
				redirectToCart();

			});

		};

		if (window.top.DY) {

			try {

				trackAddToCartDy(item.ShortSku, item.Price * item.Quantity, Number(item.Quantity));

			} catch (e) {

				console.warn('DY API is not available', e);

			}

		}

		// TODO Wait for data capture event max 2s on success callback
		const request = addToCartRequest({
			arrData: data,
			successCallback: waitForDataCaptureAndRedirectToCart,
			errorCallback: (errors, xhr, response) => {

				showAddToCartFailureModal({
					cartStatus: errors,
					response,
					fromModal: false,
					modalOptions: {
						closeEvt () {

							loadWishListItems($('.wishlistView').attr('id'));

						},
						preCloseEvt () {

							try {

								const { CartStatus, AddToCartFailures } = response;
								// 6 = quantity error
								const isQuantityError = Array.isArray(CartStatus) ? CartStatus[0] === 6 : false;
								const hasLimitedInventoryErrorMessage = Array.isArray(AddToCartFailures)
									? Boolean(
										AddToCartFailures.find((failure) => /limited inventory/gi.test(failure.ErrorMessage))
									  )
									: false;

								// if both quantity and limited inventory add to cart error, redirect to cart
								if (isQuantityError && hasLimitedInventoryErrorMessage) {

									return redirectToCart();

								}

								// returning a truthy value so modal can close
								return 1;

							} catch (ex) {

								// eslint-disable-next-line no-console
								console.error(ex);
								return 1;

							}

						}
					}
				});

			}
		});
		addClassDuringActivity($el.get(0), 'noPointerEvents', request);

	},

	setImpressionObserver () {

		const container = document.getElementById('wishlistBody');
		const listType = container && container.getAttribute('data-list-type');
		const productImpressionsReporter = new ProductImpressionsReporter({
			list_type: listType,
			product_grouping: window.utag_data.product_grouping
		});
		const productImpressionsGa4Reporter = new ProductImpressionsGa4Reporter({
			product_grouping: window.utag_data.product_grouping
		});
		const impressionObserver = productImpressionsVisibilityObserver((element) => {

			const record = productImpressionsReporter.getProductImpressionDataFromElement(element);
			productImpressionsReporter.track(record);

			const recordGa4 = productImpressionsGa4Reporter.getProductImpressionDataFromElement(element);
			productImpressionsGa4Reporter.track(recordGa4);

		});

		const elements = document.querySelectorAll('.wishlistResultProdImg');
		elements.forEach((element) => {

			impressionObserver.observe(element);

		});

	},

	handleWishlistItemNameClick (e) {

		const parentElement = e.currentTarget.closest('[data-wishlist-item]');
		const sku = parentElement ? parentElement.dataset.sku : '';

		trackWishlistActions({
			eventAction: 'Click-Product',
			eventLabel: sku
		});

	},

	handleMoreLikeThisClick (e) {

		const { sku } = e.currentTarget.dataset;

		trackWishlistActions({
			eventAction: 'Click-More-Like-This',
			eventLabel: sku || ''
		});

	}
});

export default WishlistItemView;
